module.exports = __webpack_public_path__ + "img/Warrior-Pose-Pomodoro.123ca5f9.jpg";